module.exports = __webpack_public_path__ + "img/961.88187d84.png";